import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const statements = [
  { number: "01", text: "3,5 millones de PYMEs en España.", highlight: "Todas merecen tecnología de primera." },
  { number: "02", text: "El 99% del tejido empresarial español.", highlight: "El 0% de la atención tecnológica." },
  { number: "03", text: "Estamos aquí para cambiar eso.", highlight: "Para siempre." },
];

export default function ManifestoSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section data-testid="manifesto-section" ref={ref} className="relative py-28 md:py-40 overflow-hidden">
      <div className="light-beam absolute top-0 left-0 right-0" />

      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0, x: -40 }}
          animate={isInView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="text-[#7B5EA7] text-xs font-bold tracking-[0.35em] uppercase mb-16 md:mb-24"
        >
          Manifiesto
        </motion.p>

        <div className="space-y-20 md:space-y-28">
          {statements.map((s, i) => (
            <motion.div
              key={i}
              data-testid={`manifesto-statement-${i}`}
              initial={{ opacity: 0, y: 80, x: i % 2 === 0 ? -60 : 60 }}
              animate={isInView ? { opacity: 1, y: 0, x: 0 } : {}}
              transition={{ duration: 1, delay: i * 0.25, ease: [0.22, 1, 0.36, 1] }}
              className="flex items-start gap-6 md:gap-10"
            >
              <motion.span
                initial={{ opacity: 0, scale: 0.5 }}
                animate={isInView ? { opacity: 1, scale: 1 } : {}}
                transition={{ duration: 0.8, delay: 0.3 + i * 0.25 }}
                className="text-[#00E5FF]/15 text-7xl md:text-9xl font-black leading-none tracking-tighter select-none shrink-0"
              >
                {s.number}
              </motion.span>
              <div>
                <p className="text-xl sm:text-2xl md:text-4xl lg:text-5xl font-medium text-white/75 leading-snug tracking-tight">{s.text}</p>
                <p className="text-xl sm:text-2xl md:text-4xl lg:text-5xl font-bold leading-snug tracking-tight mt-1 bg-gradient-to-r from-[#00E5FF] to-[#F5A623] bg-clip-text text-transparent">{s.highlight}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <div className="light-beam absolute bottom-0 left-0 right-0" />
    </section>
  );
}
